var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-container"},[_c('div',{staticClass:"title-content"},[_c('springText',{staticClass:"item-title",attrs:{"text":"Bounty Squad Skill Bonuses"}})],1),_c('fadeInAnimation',[_c('div',{staticClass:"sub-title"},[_vm._v(" Click the character's avatar to view skill effects and equip a wearable skin. ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }